import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/actions/dialog.service';
import { NotificationService } from 'src/app/services/actions/notification.service';
import { EventsManagerService } from 'src/app/services/events/events-manager.service';
import { FolderMenuRefreshEventsService } from 'src/app/services/events/folder-menu-refresh-events.service';
import { DraftEmailsService } from 'src/app/services/http/draft-emails.service';
import { RemindersService } from 'src/app/services/http/reminders.service';
import { AttributeDefinitionsStateService } from 'src/app/services/state/attribute-definitions-state.service';
import { ConnectedUsersStateService } from 'src/app/services/state/connected-users-state.service';
import { DocumentsStateService } from 'src/app/services/state/documents-state.service';
import { FavoriteDocumentsStateService } from 'src/app/services/state/favorite-documents-state.service';
import { NavigationStateService } from 'src/app/services/state/navigate-state.service';
import { RemindersStateService } from 'src/app/services/state/reminders-state.service';
import { BaseFolderDetailComponent } from './base-folder-detail.component';
import { ArchiveDetailDatasource } from './datasources/archive-detail-datasource';
import { DetailBaseDatasource } from './datasources/detail-base-datasource';
import { FavoritesBarComponent } from './favorites-bar/favorites-bar.component';
import { FolderDetailMenuComponent } from './folder-detail-menu/folder-detail-menu.component';
import { SectionsContainerComponent } from './sections-container/sections-container.component';

@Component({
    selector: 'app-archived-folder-detail',
    templateUrl: './base-folder-detail.component.html',
    styleUrls: ['./base-folder-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FavoritesBarComponent, FolderDetailMenuComponent, NgClass, SectionsContainerComponent],
    providers: [
        {
            provide: FavoriteDocumentsStateService,
            useClass: FavoriteDocumentsStateService,
        },
        {
            provide: DetailBaseDatasource,
            useClass: ArchiveDetailDatasource,
        },
    ]
})
export class ArchivedFolderDetailComponent extends BaseFolderDetailComponent implements OnInit {
    /**
     * Constructeur.
     * @param foldersCommentsService
     * @param remindersService
     * @param dialogService
     * @param connectedUserStateService
     * @param folderActionsService
     * @param notificationService
     * @param remindersStateService
     * @param navigateService
     * @param documentsStateService
     * @param definitionService
     * @param eventsManagerService
     * @param folderDocumentsService
     * @param folderMenuRefreshEventsService
     * @param favoriteStateService
     * @param draftEmailsService
     * @param datasource
     */
    constructor(
        protected override remindersService: RemindersService,
        protected override dialogService: DialogService,
        protected override connectedUserStateService: ConnectedUsersStateService,
        protected override notificationService: NotificationService,
        protected override remindersStateService: RemindersStateService,
        protected override navigateService: NavigationStateService,
        protected override documentsStateService: DocumentsStateService,
        protected override definitionService: AttributeDefinitionsStateService,
        protected override eventsManagerService: EventsManagerService,
        protected override folderMenuRefreshEventsService: FolderMenuRefreshEventsService,
        protected override favoriteStateService: FavoriteDocumentsStateService,
        protected override draftEmailsService: DraftEmailsService,
        protected override datasource: DetailBaseDatasource,
        protected override cdr: ChangeDetectorRef
    ) {
        super(
            remindersService,
            dialogService,
            connectedUserStateService,
            notificationService,
            remindersStateService,
            navigateService,
            documentsStateService,
            definitionService,
            eventsManagerService,
            folderMenuRefreshEventsService,
            favoriteStateService,
            draftEmailsService,
            datasource,
            cdr
        );

        this.readonly = true;
        this.isArchiveMode = true;
    }
}
